import React, { useState, Fragment } from 'react'
import SelectField from './SelectField'
import Field from './Field'

export default function SetField(props) {
  const { sets, selector_options, show_set_selector, selected_set_fields, subtext } = props.field

  console.log('PROPS FIELD', props.field)

  if (show_set_selector) {
    const [value, setValue] = useState(props.field.value || Object.keys(sets)[0])
    const [columns, setColumns] = useState(props.field.set_columns[value] || 1)

    const selectedSetFields = sets[value] || []

    const columnsVar = () => { 
      if (columns > 1) {
        return { "--columns": `${columns}` }
      } else {
        return {}
      }
    }

    return (
      <Fragment>
        <SelectField {...props} field={props.field} options={selector_options} onChange={(value) => setValue(value)} />
        {subtext ? (
          <small className="text-muted d-block mt-1">{subtext}</small>
        ) : null}
        <div className={`producer-form-set ${columns > 1 ? "producer-form-group" : ""}`} style={columnsVar()}>
          {selectedSetFields.map((field) => {
            if (columns > 1) {
              return (
                <div className="producer-form-group-item" style={{"--span": field.span || 1}}>
                  <Field {...props} key={field.key} field={field} />
                </div>
              )
            } else {
              return <Field {...props} key={field.key} field={field} />
            }
          })}
        </div>
      </Fragment>
    )
  } else {
    return (
      <Fragment>
        {selected_set_fields.map((field) => <Field {...props} key={field.key} field={field} />)}
      </Fragment>
    )
  }

}
